import { TopBrandsRow } from '@/components/atomic/atoms';
import { Text } from '@/components/atomic/nuclei';
import { splitArrayIntoChunks } from '@/services/homePage.service';

const chunkedBlankRows = splitArrayIntoChunks({
  chunkSize: 2
});

const chunkedLogos = splitArrayIntoChunks({
  chunkSize: 8
});

const BlankRowAndCells = () => (
  <tr className='top-empty-row'>
    {chunkedBlankRows.map(({ logoURL }, index) => (
      <td key={`${logoURL}-${index}`}></td>
    ))}
  </tr>
);

const TopBrandsWeb = () => (
  <div className='top-brands-header-mobile bg-white mb-10'>
    <div className='block'>
      <Text
        {...{
          className:
            'text-light-silver text-xs md:text-xl font-medium uppercase text-center top-brands-header-mobile md:top-brands-header-web',
          content: 'Trusted by top brands'
        }}
      />
      <div className='flex items-center justify-center justify-self-center justify-items-center h-48 my-3'>
        <table className='border-collapse bg-white table-container wave-border'>
          <tbody>
            <BlankRowAndCells />
            {chunkedLogos.map((renderRow, index) => (
              <TopBrandsRow
                key={`${index}-${Math.random()}`}
                {...{ renderRow }}
              />
            ))}
            <BlankRowAndCells />
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default TopBrandsWeb;
